import React, { FC, useState } from "react";
import { Accordion, Tab, Tabs, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  startAddFrom,
  startLoadForm,
  startRemoveForm,
} from "../../actions/formListAction";
import { startEditSession } from "../../actions/sessionListAction";
import { AppState } from "../../reducers/rootReducer";
import { SystemTypes } from "../../utils/constants";
import ElementItemList from "./elementItemList";
import "./elementpanel.scss";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
import ProjectComponent from "./projectComponent";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { animated, useTransition } from "react-spring";

const ElementPanelComponent: FC = () => {
  const dispatch = useDispatch();
  const formState = useSelector((state: AppState) => state.formList);
  const sessionState = useSelector((state: AppState) => state.session);
  const projectList = useSelector((state: AppState) => state.projectList);

  const [projectPanal, setProjectPanal] = useState(false);
  const transistion = useTransition(projectPanal, {
    from: { x: -150, y: 0, opacity: 0 },
    enter: { x: 0, y: 0, opacity: 1 },
    leave: { x: -150, y: 0, opacity: 0 },
  });

  const btnTransition = useTransition(projectPanal, {
    from: { width: 0, y: 0, opacity: 0 },
    enter: { width: 65, y: 0, opacity: 1, display: "block" },
    leave: { width: 0, y: 0, opacity: 0, display: "none" },
  });

  const transisionProjectPanal = useTransition(projectPanal, {
    from: { width: 0, y: 0, opacity: 0 },
    enter: { width: 300, y: 0, opacity: 1 },
    leave: { width: 0, y: 0, opacity: 0 },
  });

  const formList = formState.filter((form) => {
    return form.type === "form";
  });

  const modelList = formState.filter((model) => {
    return model.type === "model";
  });

  const alertList = formState.filter((model) => {
    return model.type === "alert";
  });
  // adding new form
  const handleButtonCreateNewForm = () => {
    dispatch(
      startAddFrom({
        name: "New form",
        projectId: sessionState.selectedProjectId,
        type: "form",
        modalAttribute: {},
        alertAttribute: {},
      })
    );
  };

  // adding new model
  const handleButtonCreateNewModel = () => {
    dispatch(
      startAddFrom({
        name: "New modal",
        projectId: sessionState.selectedProjectId,
        type: "model",
        modalAttribute: { title: "", modalLarge: "", modelCentered: "" },
        alertAttribute: {},
      })
    );
  };

  // adding new alert
  const handleButtonCreateNewAlert = () => {
    dispatch(
      startAddFrom({
        name: "New alert",
        projectId: sessionState.selectedProjectId,
        type: "alert",
        modalAttribute: {},
        alertAttribute: {
          message: "",
          displayTime: 5,
          notificationType: "",
          position: "",
        },
      })
    );
  };

  const formTabs = () => {
    return (
      <Tabs defaultActiveKey="forms" id="form-tab">
        <Tab
          eventKey="forms"
          title={
            <Tooltip title="FORMS">
              <i className="fa fa-file-text" aria-hidden="true"></i>
            </Tooltip>
          }
        >
          <div className="row">
            <div className="col-12">
              {/* <span>FORMS</span> */}
              {formList
                ? formList.map((form, i) => (
                    <div
                      className="form-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(startLoadForm(form));
                      }}
                    >
                      <span
                        className={`form-name ${
                          sessionState.selectedFormId === form.id
                            ? "form-active"
                            : ""
                        }`}
                      >
                        {form.name}
                      </span>
                      <button
                        className="form-remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(startRemoveForm(form.id));
                        }}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </button>
                    </div>
                  ))
                : null}
            </div>
            <div className="col-12 m-2 p-2">
              <button
                type="button"
                className="form-button"
                onClick={handleButtonCreateNewForm}
              >
                <i className="fa fa-plus-square-o" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Tab>
        <Tab
          eventKey="models"
          title={
            <Tooltip title="MODALS">
              <i className="fa fa-window-restore" aria-hidden="true"></i>
            </Tooltip>
          }
        >
          <div className="row">
            <div className="col-12">
              {modelList
                ? modelList.map((model, i) => (
                    <div
                      className="form-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(startLoadForm(model));
                      }}
                    >
                      <span
                        className={`form-name ${
                          sessionState.selectedFormId === model.id
                            ? "form-active"
                            : ""
                        }`}
                      >
                        {model.name}
                      </span>
                      <button
                        className="form-remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(startRemoveForm(model.id));
                        }}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </button>
                    </div>
                  ))
                : null}
            </div>
            <div className="col-12 m-2 p-2">
              <button
                type="button"
                className="form-button"
                onClick={handleButtonCreateNewModel}
              >
                <i className="fa fa-plus-square-o" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Tab>
        <Tab
          eventKey="alerts"
          title={
            <Tooltip title="ALERTS">
              <i className="fa fa-bell" aria-hidden="true"></i>
            </Tooltip>
          }
        >
          <div className="row">
            <div className="col-12">
              {alertList
                ? alertList.map((model, i) => (
                    <div
                      className="form-item"
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(startLoadForm(model));
                      }}
                    >
                      <span
                        className={`form-name ${
                          sessionState.selectedFormId === model.id
                            ? "form-active"
                            : ""
                        }`}
                      >
                        {model.name}
                      </span>
                      <button
                        className="form-remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          dispatch(startRemoveForm(model.id));
                        }}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </button>
                    </div>
                  ))
                : null}
            </div>
            <div className="col-12 m-2 p-2">
              <button
                type="button"
                className="form-button"
                onClick={handleButtonCreateNewAlert}
              >
                <i className="fa fa-plus-square-o" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Tab>
      </Tabs>
    );
  };

  const renderProjectList = () => {
    return projectList.map((project, i) => {
      return <ProjectComponent project={project} index={i} />;
    });
  };
  return transisionProjectPanal((style, item) =>
    item ? (
      btnTransition((style, item) =>
        item ? (
          <animated.div style={style} className="collapsive-btn-hide-panal">
            <Tooltip title="Show Project panel" position="right-end">
              <Button
                variant="dark"
                className="collapsive-btn pl-25"
                onClick={() => setProjectPanal((projectPanal) => !projectPanal)}
              >
                {" "}
                <FiChevronRight className="color-white" />{" "}
              </Button>
            </Tooltip>
          </animated.div>
        ) : (
          ""
        )
      )
    ) : (
      <animated.div className={` element-panel `} style={style}>
        <div className="project-title-area">
          {transistion((style, item) =>
            item ? (
              ""
            ) : (
              <animated.div style={style} className="m-2 p-2">
                <span className="color-white theam-font">PROJECTS</span>
              </animated.div>
            )
          )}

          {transistion((style, item) =>
            item ? (
              ""
            ) : (
              <animated.div className="p-2" style={style}>
                <Tooltip title="Hide Project Panel" position="right-end">
                  <Button
                    variant="dark"
                    className="collapsive-btn  collapsive-btn-align-right"
                    onClick={() =>
                      setProjectPanal((projectPanal) => !projectPanal)
                    }
                  >
                    <FiChevronLeft className="color-white" />
                  </Button>
                </Tooltip>
              </animated.div>
            )
          )}
        </div>
        {transistion((style, item) =>
          item ? (
            ""
          ) : (
            <animated.div
              className="project-panal"
              id="accordion"
              style={style}
            >
              {renderProjectList()}
            </animated.div>
          )
        )}
      </animated.div>
    )
  );
};

export default ElementPanelComponent;
